import React, { useState } from "react";
import { database, ref, get } from "./firebase";

export default function Login({ onLogin }) {
  const [phone, setPhone] = useState("");

  const handleLogin = async () => {
    if (!phone.match(/^\d{10}$/)) {
      alert("Enter valid 10-digit number");
      return;
    }

    const userRef = ref(database, `users/${phone}`);
    const snap = await get(userRef);

    if (!snap.exists()) {
      alert("This number is not registered");
      return;
    }

    const role = snap.val().role;
    onLogin({ phone, role });
  };

  return (
    <div style={{
      padding: 20,
      height: "100vh",
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      backgroundColor: "#ffe6f0"
    }}>
      <h1 style={{
        fontFamily: "'Herr Von Muellerhoff', cursive",
        fontSize: "48px",
        color: "#ff1493",
        marginBottom: "30px"
      }}>Jauhari</h1>

      <h3>Login with Mobile Number</h3>
      <input
        type="text"
        placeholder="Enter 10-digit number"
        value={phone}
        onChange={(e) => setPhone(e.target.value)}
        style={{ padding: 10, fontSize: 16, marginBottom: 10, borderRadius: 4, border: "1px solid #ccc", width: 250 }}
      />
      <button
        onClick={handleLogin}
        style={{ padding: "10px 20px", backgroundColor: "#ff1493", color: "white", border: "none", borderRadius: 4, cursor: "pointer" }}
      >
        Login
      </button>
    </div>
  );
}
